var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPowerPoint = function SvgPowerPoint(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 140,
    viewBox: "0 0 296 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7277_9211)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 295,
    height: 139,
    rx: 2.5,
    fill: "#F5F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.551 53.9996C119.551 47.1242 125.124 41.5507 132 41.5507H164C170.875 41.5507 176.448 47.1242 176.448 53.9996V85.9996C176.448 92.8749 170.875 98.4485 164 98.4485H132C125.124 98.4485 119.551 92.8749 119.551 85.9996V53.9996Z",
    stroke: "#8D83FB",
    strokeWidth: 3.54667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 64.667H156.381",
    stroke: "#8D83FB",
    strokeWidth: 2.93333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.19 64.667V75.3337",
    stroke: "#8D83FB",
    strokeWidth: 2.93333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 72.286H135.048C136.058 72.286 137.027 71.8847 137.741 71.1703C138.456 70.4558 138.857 69.4869 138.857 68.4765C138.857 67.4662 138.456 66.4972 137.741 65.7828C137.027 65.0684 136.058 64.667 135.048 64.667H132V75.3337",
    stroke: "#8D83FB",
    strokeWidth: 2.93333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.952 72.286H148C149.01 72.286 149.979 71.8847 150.694 71.1703C151.408 70.4558 151.809 69.4869 151.809 68.4765C151.809 67.4662 151.408 66.4972 150.694 65.7828C149.979 65.0684 149.01 64.667 148 64.667H144.952V75.3337",
    stroke: "#8D83FB",
    strokeWidth: 2.93333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 295,
    height: 139,
    rx: 2.5,
    stroke: "#8D83FB",
    strokeDasharray: "4.5 4.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7277_9211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 140,
    rx: 3,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPowerPoint);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";